"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Philosophy() {
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.4
  });
  const {
    ref: pillarsRef,
    isVisible: pillarsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const allWords: {
    text: string;
    italic: boolean;
  }[] = [];
  allWords.push({
    text: "No",
    italic: false
  });
  allWords.push({
    text: "buscamos",
    italic: false
  });
  allWords.push({
    text: "milagros.",
    italic: false
  });
  allWords.push({
    text: "Buscamos",
    italic: false
  });
  allWords.push({
    text: "la",
    italic: false
  });
  allWords.push({
    text: "armonía",
    italic: true
  });
  allWords.push({
    text: "natural",
    italic: false
  });
  allWords.push({
    text: "que",
    italic: false
  });
  allWords.push({
    text: "define",
    italic: false
  });
  allWords.push({
    text: "tu",
    italic: false
  });
  allWords.push({
    text: "esencia.",
    italic: false
  });
  const lineBreakAfter = [2, 5, 8];
  const pillars = [{
    number: "I.",
    title: "Excelencia Médica",
    body: "Cada diagnóstico es un compromiso con la salud. Aplicamos protocolos de vanguardia en tricología y cirugía capilar, priorizando siempre la seguridad, la ética profesional y el bienestar integral de nuestros pacientes."
  }, {
    number: "II.",
    title: "Resultados Naturales",
    body: "Nuestra filosofía se aleja de lo artificial. Diseñamos cada intervención para respetar la anatomía única de tu rostro, logrando una densidad y un diseño de línea frontal que se integran con tu imagen de forma imperceptible."
  }, {
    number: "III.",
    title: "Atención Personalizada",
    body: "Entendemos que cada caso es único. Desde la primera consulta hasta el seguimiento final, te acompañamos con un trato humano, cercano y privado, garantizando que te sientas escuchado y respaldado en todo el proceso."
  }];
  return;
}